import { connect } from 'react-redux';
import { createAccount } from 'data/accounts/accounts.actions';
import AccountCreatedContainer from './AccountCreatedContainer';

const key = Symbol('CreateAccount');

const actions = {
  createAccount: account => createAccount(account, key)
};

function mapStateToProps(state) {
  return {
    ...state.accounts[key]
  };
}

export default connect(mapStateToProps, actions)(AccountCreatedContainer);
